<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/12tn6m0/tc-custom/9781614170853.jpg?1685327059593" alt="This image is the cover for the book Orchids in Moonlight"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Orchids in Moonlight
      </h1>
      <p class="bookDescription body article font2">
        <b>A Young Woman Searching for Her Father, Loses Her Heart to Her Outcast Guide in <i>Orchids in Moonlight</i> a Historical Western Romance by Patricia Hagan</b><br/><br/>Together, the lovers ride the dangerous Sierra Nevada ranges.<br/><br/>Jaime Chandler, searching for her father, is finally in the care of the one man—Cord Austin—who can safely lead her to San Francisco.<br/><br/>Cord Austin guards a dark secret and intends to leave his passion for Jaime behind in the dust.<br/><br/>But when Jaime's search for her father ends in an unexpected web of treachery and deceit, the lovers discover a truth neither dare deny.<br/><br/><b>THE SOULS AFLAME SERIES by Patricia Hagan</b><br/><i>This Rebel Heart<br/>This Savage Heart</i><br/><br/><b>OTHER TITLES by Patricia Hagan</b><br/><i>Say You Love Me<br/>Starlight<br/>Simply Heaven<br/>Orchids in Moonlight<br/>Final Justice<br/>Forbidden to Love<br/>Passion's Fury</i><br/><br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Patricia Hagan
      </h2>
      
      <p class="authorDescription body article">Patricia Hagan is a New York Times bestselling author of 42 novels, proud mother of a U.S. Navy SEAL and is a native of Alabama.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      ePublishing Works!
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?52076720